import useSWR from 'swr';
import { Dataset } from '@/lib/types/Dataset';
import { Table } from '@/lib/types/Table';
export const useDataset = (datasetId: string) => {
  return useSWR<Dataset | null>(`/api/dataset/${datasetId}`);
};
function findTable(tables?: Table[], tableName: string = tables?.[0].name ?? '') {
  if (!tableName || !tables) {
    return null;
  }
  return tables.find(table => table.name === tableName || table.id === tableName);
}
export const useDatasetTable = (datasetId: string, tableId?: string) => {
  const {
    data: dataset
  } = useDataset(datasetId);
  return {
    dataset,
    table: findTable(dataset?.tables, tableId)
  };
};
export const useFindTable = (dataset: Dataset, tableName?: string) => {
  return {
    table: findTable(dataset?.tables, tableName)
  };
};